
function sommarioConsumiFornitori () {

  

    this.$eventBus.emit('show-dialog-page', {
      page: 'pods-sommario-consumi-fornitori',
      title: 'Sommario Consumi Fornitori',
      data: [],
      maximize: false,

    })
  
}

export default {
  'bindTo': 'this',
  'method': sommarioConsumiFornitori,
}
